module.exports = __webpack_public_path__ + "static/media/ph_map.57677ec4.jpg";